import script from "./AlarmPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./AlarmPopup.vue?vue&type=script&setup=true&lang=js"

import "./AlarmPopup.vue?vue&type=style&index=0&id=4701af1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4701af1c"]])

export default __exports__